module.exports = __webpack_public_path__ + "img/broadcast-school-icon2.2c8ed963.png";